import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id FCAD03B0-9332-41AF-9992-AF53DDDF6BBA
 * name minus-box-multiple-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-box-multiple-outline.svg
 * tags
 * - Form 
 */
export const MinusBoxMultipleOutlineIcon = createSvgIcon(<><path d="M18 11H10V9H18M20 4V16H8V4H20M20 2H8C6.9 2 6 2.9 6 4V16C6 17.11 6.9 18 8 18H20C21.11 18 22 17.11 22 16V4C22 2.9 21.11 2 20 2M4 6H2V20C2 21.11 2.9 22 4 22H18V20H4V6Z" /></>, 'MinusBoxMultipleOutlineIcon');
export default MinusBoxMultipleOutlineIcon